import { CompanyAccountModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const defaultDto: CompanyAccountModelDto = {
    id: 0,
    name: '',
    number: '',
    cifNumber: '',
    status: '',
    type: '',
    accountUniqueId: '',
};

export class AchOffsetAccount extends DomainEntity<CompanyAccountModelDto> {
    constructor(
        dto: CompanyAccountModelDto = defaultDto,
        private _managed: boolean = false
    ) {
        super(dto);
    }

    public createDefault(): this {
        return new AchOffsetAccount() as this;
    }

    public get id(): number {
        return this.dto.id;
    }

    public get managed(): boolean {
        return this._managed;
    }

    public set managed(value: boolean) {
        this._managed = value;
    }

    public get name(): string {
        return this.dto.name;
    }

    public get number(): string {
        return this.dto.number;
    }

    public get cifNumber(): string {
        return this.dto.cifNumber ?? '';
    }

    public get type(): string {
        return this.dto.type ?? '';
    }
}
